import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { AppConfig } from 'src/app/app.config';
import { envThemeModel } from './env-theme-abstract-model';

@Injectable({
    providedIn: 'root'
})
export class envTheme implements envThemeModel {

    constructor(@Inject(DOCUMENT) private document: Document) {
        this.loadTheme(AppConfig.settings?.env?.name.toLowerCase());
    }

    private loadTheme(environment: string) {
        const existingLinkEl = this.document.getElementById('env-theme') as HTMLLinkElement;
        if (existingLinkEl) {
            existingLinkEl.href = 'assets/css/material-' + environment + '.css';

        } else {
            const headEl = this.document.getElementsByTagName('head')[0];
            const newLinkEl = this.document.createElement('link');
            newLinkEl.id = 'env-theme';
            newLinkEl.rel = 'stylesheet';
            if(environment === 'lab') {
                newLinkEl.href = 'assets/css/material-dev.css';
                headEl.appendChild(newLinkEl);
            }
            else {
                newLinkEl.href = 'assets/css/material-' + environment + '.css';
                headEl.appendChild(newLinkEl);
            }

            
        }
    }
}